import React from 'react';

import { UserRole } from '@appUtils/tripConverter';
import UserRoleList from '../UserRoleList';

const Passengers = () => <UserRoleList role={UserRole.PASSENGER} withActions />;

export default Passengers;
